
<!--
  功能：图表——柱状图
-->
<template>
  <div :id="chartsName" :style="{width: '100%', height: '350px'}"></div>
</template>
<script>
import * as echarts from 'echarts'
// 表单验证
// import { notNullable, dailyBudget } from '@/components/form/formValidation'
// 公用
// import { strSubstring } from '@/components/public'

export default {
  // 组件名称
  name: 'histogramCharts',
  // 组件参数 接收来自父组件的数据
  props: {
    chartsName: {
      type: String
    },
    chartsType: {
      type: String
    },
    chartsDate: {
      type: Array
    },
    chartsTotalDate: {
      type: Array
    },
    chartsXAxisData: {
      type: Array
    },
    chartsColor: {
      type: Array
    },
    scrollBar: {
      type: Boolean
    },
    showPercent: {
      type: Boolean,
      default: false
    }
  },
  created () {
  },
  mounted () {
    console.log('chartsDate', this.chartsDate)
    this.drawCharts()
  },
  // 组件状态值
  data() {
    return {
      myChart: ''
    }
  },
  watch: {
    chartsDate() {
      console.log('chartsDate', this.chartsDate)
      this.myChart.dispose() // 销毁
      this.drawCharts()
    }
  },
  methods: {
    cal_Max(arr) {
      let max = 0
      arr.forEach(item => {
        item = parseInt(item)
        if (item > max) {
          max = item
        }
      })
      console.log(max)
      return max
    },
    drawCharts () {
      let thisChartsData = {
        series: [],
        legend: [],
        yAxis: []
      }
      if (this.chartsType === 'line') {
        // 折线图
        this.chartsDate.forEach((item) => {
          let thisItem = {
            name: item.name,
            type: 'line',
            // stack: 'Total',
            data: item.data
          }
          thisChartsData.series.push(thisItem)
          thisChartsData.legend.push(item.name)
        })
      } else if (this.chartsType === 'bar') {
        // 柱形图
        this.chartsDate.forEach((item, index) => {
          let thisYAxis = {}
          let Max = this.cal_Max(item.data)
          if (Max > 0) {
            thisYAxis = {
              type: 'value',
              name: item.name,
              min: 0,
              max: Max * 1.2,
              splitNumber: 5,
              interval: (Max * 2 - 0) / 5
            }
          } else {
            thisYAxis = {
              type: 'value',
              name: item.name
            }
          }
          if (item.name === '点击率' || item.name === '转化率') {
            // 百分比
            thisYAxis.axisLabel = {
              formatter: '{value}%'
            }
          }
          let thisItem = {
            name: item.name,
            type: 'bar',
            barWidth: (100 - 30) / this.chartsDate.length + '%',
            barGap: '0',
            yAxisIndex: index,
            data: item.data
          }
          thisChartsData.series.push(thisItem)
          thisChartsData.legend.push(item.name)
          thisChartsData.yAxis.push(thisYAxis)
        })
      } else if (this.chartsType === 'pie') {
        // 饼图
        // console.log(this.chartsDate, this.chartsTotalDate)
        if (this.showPercent) {
          // 占比分析
          // 有百分比与文字的饼图（占比关系）
          thisChartsData.series = [{
            name: '',
            type: 'pie',
            // radius: '80%',
            top: '8%',
            radius: ['35%', '80%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 5,
              borderColor: '#fff',
              borderWidth: 2
            },
            data: this.chartsTotalDate
          }, {
            name: this.chartsDate[0],
            type: 'pie',
            // radius: '80%',
            top: '8%',
            radius: ['35%', '80%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 5,
              borderColor: '#fff',
              borderWidth: 2,
              normal: {
                label: {
                  show: true,
                  position: 'outer',
                  fontSize: 12,
                  fontWeight: 'bold',
                  align: 'left',
                  formatter: function (p) { // 指示线对应文字，说明文字
                    return p.data.name
                  }
                },
                labelLine: { // 指示线状态
                  show: true,
                  smooth: 0.2,
                  length: 20,
                  length2: 20
                }
              }
            },
            data: this.chartsDate[1]
          }, {
            name: this.chartsDate[0],
            type: 'pie',
            // radius: '80%',
            top: '8%',
            radius: ['35%', '80%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 5,
              borderColor: '#fff',
              borderWidth: 2,
              normal: {
                label: {
                  show: true,
                  position: 'inner',
                  fontSize: 12,
                  color: '#fff',
                  fontWeight: 'bold',
                  align: 'left',
                  formatter: function (p) { // 指示线对应文字,百分比
                    let str = p.percent + ''
                    let result = str.substring(str.indexOf('.') + 1, str.indexOf('.') + 5)
                    if (result.length > 2) {
                      return p.percent.toFixed(2) + '%'// 设置百分比保留几位小数
                    } else {
                      return p.percent + '%'
                    }
                  }
                },
                labelLine: { // 指示线状态
                  show: true,
                  smooth: 0.2,
                  length: 20,
                  length2: 20
                }
              }
            },
            data: this.chartsDate[1]
          }]
        } else {
          thisChartsData.series = [{
            name: this.chartsDate[0],
            type: 'pie',
            // radius: '80%',
            top: '8%',
            radius: ['35%', '80%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 5,
              borderColor: '#fff',
              borderWidth: 2
            },
            data: this.chartsDate[1]
          }]
        }
      }
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.getElementById(this.chartsName))
      // 绘制图表
      let option = {}
      if (this.chartsType === 'line') {
        option = {
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '4%',
            right: '6%',
            bottom: '3%',
            containLabel: true
          },
          legend: {
            data: thisChartsData.legend
          },
          yAxis: {
            type: 'value'
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: this.chartsXAxisData
            }
          ]
        }
      } else if (this.chartsType === 'bar') {
        // 柱形图
        option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          legend: {
            data: thisChartsData.legend
          },
          xAxis: [
            {
              type: 'category',
              data: this.chartsXAxisData,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: thisChartsData.yAxis
        }
        console.log('scrollBar', this.scrollBar)
        if (this.scrollBar) {
          option.grid.bottom = '15%'
          option.dataZoom = [
            {
              type: 'slider',
              show: true, // flase直接隐藏图形
              xAxisIndex: [0],
              start: 0, // 滚动条的起始位置
              end: 50 // 滚动条的截止位置（按比例分割你的柱状图x轴长度）
            }
          ]
        }
      } else if (this.chartsType === 'pie') {
        // 饼图
        option = {
          tooltip: {
            trigger: 'item'
          },
          legend: {
            left: 'center'
          }
        }
      }
      // 图表数据
      option.series = thisChartsData.series
      // 图表颜色
      if (this.chartsColor.length > 0) {
        option.color = this.chartsColor
      }
      console.log(option)
      // set数据
      option && this.myChart.setOption(option)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/echarts/histogramCharts.vue